import { useNavigate } from '@tanstack/react-router';

import RegistrationSuccess from '@/components/organism/Registration/RegistrationSuccess';
import { clearRegistrationSession } from '@/utils/sessionStorage';

export const RegistrationSuccessPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    clearRegistrationSession();
    void navigate({ to: '/login' });
  };

  return <RegistrationSuccess onContinue={handleContinue} />;
};
